import {MONTHLY_SUMMARY_SET_ACTIVE_CHART_TYPE, 
        FETCH_MONTHLY_SUMMARY_PREVIOUS_DATA_SUCCESS,
        FETCH_MONTHLY_SUMMARY_NEXT_DATA_SUCCESS,
        MONTHLY_SUMMARY_UPDATE_ACTIVE_INDEX,
        MONTHLY_SUMMARY_UPDATE_ACTIVE_MODE,
        MONTHLY_SUMMARY_API_ERROR,
        FETCHING_MONTHLY_SUMMARY_DATA,
        MONTHLY_SUMMARY_DATA_RESET
    } 
        from '../../actions/monthlySummaryActions';
import { cloneObject } from '../../helpers/helper';

const defaultState = {
    activeChartType: 'Bar',
    monthlySummaryDataArray : [],
    monthlySummaryActiveIndex : 0,
    rightArrowDisabled : true,
    leftArrowDisabled: false,
    activeMode : null,
    apiError: false,
    fetchingData : false,
    apiFailed : false
};

const monthlySummaryDataReducer = (state = cloneObject(defaultState), action) => {
    switch (action.type) {
        case MONTHLY_SUMMARY_SET_ACTIVE_CHART_TYPE:
            state = {
                ...state,
                ...action.payload
            };
            break;
        case FETCH_MONTHLY_SUMMARY_PREVIOUS_DATA_SUCCESS : {
            let disablePreviousArrow = false;
            if(!action.payload.previousBillStart){
                disablePreviousArrow = true;
            }
            let monthlySummaryDataArrayUpdated = [action.payload];
            let concatinatedArray = monthlySummaryDataArrayUpdated.concat(state.monthlySummaryDataArray);
            state = {
                ...state,
                monthlySummaryDataArray : concatinatedArray,
                leftArrowDisabled : disablePreviousArrow,
                monthlySummaryActiveIndex : 0,
                rightArrowDisabled : false,
                fetchingData: false
            };
            break;
        }  
        case FETCH_MONTHLY_SUMMARY_NEXT_DATA_SUCCESS : {
            let apiError = false;
            if(!action.payload.itemizationDetails.electric && !action.payload.itemizationDetails.gas){
                apiError = true;
            }
            let disableNextArrow = false;
            if(!action.payload.nextBillStart){
                disableNextArrow = true;
            }
            let monthlySummaryDataArrayUpdated = state.monthlySummaryDataArray;
            monthlySummaryDataArrayUpdated.push(action.payload);
            state = {
                ...state,
                monthlySummaryDataArray: monthlySummaryDataArrayUpdated,
                rightArrowDisabled: disableNextArrow,
                leftArrowDisabled : false,
                monthlySummaryActiveIndex : monthlySummaryDataArrayUpdated.length - 1,
                fetchingData : false,
                apiError: apiError
            }
            break;
        }   
        case MONTHLY_SUMMARY_UPDATE_ACTIVE_INDEX : {
            let disablePreviousArrow = false, disableNextArrow = false;
            if(!state.monthlySummaryDataArray[state.monthlySummaryActiveIndex + action.payload].previousBillStart){
                disablePreviousArrow = false
            }
            if(!state.monthlySummaryDataArray[state.monthlySummaryActiveIndex + action.payload].nextBillStart){
                disableNextArrow = true;
            }
            state = {
                ...state,
                monthlySummaryActiveIndex : state.monthlySummaryActiveIndex + action.payload,
                leftArrowDisabled: disablePreviousArrow,
                rightArrowDisabled : disableNextArrow,
                fetchingData : false
            }
            break;
        }
        case MONTHLY_SUMMARY_UPDATE_ACTIVE_MODE : {
            state = {
                ...state,
                activeMode : action.payload
            }
            break;
        }
        case MONTHLY_SUMMARY_API_ERROR : {
            state = {
                ...state,
                apiFailed : true
            }
            break;
        }
        case FETCHING_MONTHLY_SUMMARY_DATA : {
            state = {
                 ...state,
                 fetchingData : true
            }
            break;
        }
        case MONTHLY_SUMMARY_DATA_RESET: {
            state = cloneObject(defaultState);
            break;
        }
        default:
            break;
    }
    return state;
}
  
export default monthlySummaryDataReducer;